import {Component, Input} from '@angular/core';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {_AQH_EVE_25, AQH_EVE_28} from '../../../../../../../../../../@shared/models/input.module';
import {EventContactRoleResponse, EventResponse} from '../../../../../../../../../../@shared/models/response.module';

@Component({
  selector: 'app-add-contact',
  standalone: false,
  templateUrl: './add-contact.html',
  styleUrl: './add-contact.css'
})
export class AddContact {
  @Input() event: EventResponse

  first_name = '';
  last_name = '';
  phone = '';
  email = '';
  role_id: number | null = null;

  roles: EventContactRoleResponse[] = [];
  loadingRoles: boolean = false;

  constructor(private eventsService: EventsService,
              private modal: NgbActiveModal) {
  }

  ngOnInit() {
    this.loadRoles();
  }

  loadRoles() {
    this.loadingRoles = true;
    let payload: AQH_EVE_28 = {};
    this.eventsService.getEventContactRoles(payload).subscribe({
      next: (res: EventContactRoleResponse[]) => {
        this.roles = res;
        this.loadingRoles = false;
      },
      error: () => {
        this.loadingRoles = false;
        this.roles = [];
      }
    });
  }

  onSave() {
    if (!this.first_name.trim() || !this.last_name.trim() || this.role_id == null) {
      return;
    }

    const payload: _AQH_EVE_25 = {
      event_id: this.event.event_id,
      first_name: this.first_name.trim(),
      last_name: this.last_name.trim(),
      phone: this.phone.trim(),
      email: this.email.trim(),
      role_id: this.role_id
    };

    this.eventsService.addEventContact(payload).subscribe((res: any) => {
      this.modal.close(res.data);
    })
  }

  close() {
    this.modal.close();
  }
}
